import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-locations",
  "use": "icon-locations-usage",
  "viewBox": "0 0 14 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 20\" id=\"icon-locations\"><path d=\"M7 18.853a45.763 45.763 0 0 1-2.878-3.804c-.861-1.276-1.711-2.698-2.344-4.11C1.141 9.519.75 8.162.75 7A6.245 6.245 0 0 1 7 .75 6.245 6.245 0 0 1 13.25 7c0 1.16-.391 2.518-1.028 3.94-.633 1.412-1.483 2.833-2.344 4.11A45.763 45.763 0 0 1 7 18.852ZM3.75 7a3.25 3.25 0 0 0 6.5 0 3.25 3.25 0 0 0-6.5 0Z\" stroke=\"currentColor\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol